export enum ItemClass {
  CURRENT = 'current-day',
  ENROLLEDPAST = 'enrolled-past-day',
  UNENROLLEDPAST = 'unenrolled-past-day',
  ENROLLED = 'enrolled-day',
  UNENROLLED = 'unenrolled-day',
}
